import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { HistApi } from 'src/app/services/api-service/hist/hist-api';
import { WholeHist } from 'src/app/services/api-service/hist/whole-hist';
import { ParameterApi } from 'src/app/services/api-service/parameters/parameter-api';
import { RegisterEditDto } from 'src/app/services/api-service/register/RegisterEditDto';
import { RegisterApi } from 'src/app/services/api-service/register/register-api';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { UserCache } from 'src/app/services/user-cache';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { Clinic } from 'src/app/system/clinic/models/clinic';

@Component({
  selector: 'app-register-report',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  @ViewChild('reportContainer')
  reportContainer: ElementRef<HTMLDivElement>;
  regist: RegisterEditDto;
  clinic: Clinic;

  cidMask = '1234567890';
  bitrhMask = 'YYY年MM月DD日';
  fontType: string;
  type: number = 1;
  hist: WholeHist;

  @Input()
  set regId(id) {
    this.setRegId(id);
  }
  constructor(private api: RegisterApi,
    private histApi: HistApi,
    private parameterApi: ParameterApi,
    private clinicDataService: ClinicDataService,
    private cdr: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    // var st = document.createElement('style');
    // st.appendChild(document.createTextNode(
    //   '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
    //   '.reg-report table{ border:1px solid black; border-collapse: collapse;width:calc(100% - 40px);margin:5px 20px; }\n' +
    //   '.reg-report table td, table th { border: 1px solid black;padding: 5px;vertical-align: baseline;}\n' +
    //   '.reg-report table tr:first-child th { border-top: 0; }\n' +
    //   '.reg-report table tr:last-child td { border-bottom: 0; }\n' +
    //   '.reg-report table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
    //   '.reg-report table tr td:last-child, table tr th:last-child { border-right: 0; }'
    // ));
    // setTimeout(() => {
    //   this.reportContainer.nativeElement.appendChild(st);
    // }, 0);
  }
  get clinicName() {
    return this.clinic?.Name;
  }
  get patientNo() {
    return this.regist?.PatientNo;
  }
  get patientShortNo() {
    return this.regist?.PatientNo?.replace(/^0+/, '');
  }
  get patientName() {
    return this.regist?.PatientFirstName;
  }
  get patientBirth() {
    return this.regist?.PatientBirth;
  }
  get patientSex() {
    return this.regist?.PatientSexName;    
  }
  get regDate() {
    return this.regist?.RegDate;
  }
  get regTime() {
    return DateHelper.getHourMinTime(this.regist?.RegDate, true);
  }
  get regSec() {
    return this.regist?.TimeSecName;
  }
  get room() {
    return this.regist?.RoomName;
  }
  get medDeptName() {
    return this.regist?.MedDeptName;
  }
  get doctorName() {
    return this.regist?.DoctorName;
  }
  get waitNo() {
    return this.regist?.WaitNo;
  }
  get remark() {
    return this.regist?.Remark;
  }
  get address() {
    return this.clinic.City + this.clinic.Area + this.clinic.Street;
  } 
  get clinicPhone() {
    return this.clinic.Phone;
  }
  get visitSourceName() {
    return this.hist?.Register?.VisitTypeName;
  }
  get iCodeName() {
    return this.hist?.Register?.ICodeName;
  }
  get registerFee() {
    return this.regist?.RegisterFee.toFixed(0);
  }
  get ownFee() {
    return this.regist?.OwnFee.toFixed(0);
  }
  get deposit() {
    return this.regist?.Deposit.toFixed(0);
  }
  get selfPay() {
    return this.regist?.SelfPay.toFixed(0);
  }
  get icno() {
    return this.regist?.Icno;
  }

  async setRegId(regId: number) {
    this.clinic = UserCache.getLoginUser().Clinic;
    this.regist = await this.api.Get(regId);
    this.hist = await this.histApi.getWholeHist({ regId: regId });
    var param = await this.clinicDataService.getParam("PRN001");
    this.cidMask = param.IDHidePRN ?? this.cidMask;
    this.bitrhMask = param.BirthdayHidePRN ?? this.bitrhMask;
    this.fontType = (param.FontTypeForPrint == 0 ? '細明體' : (param.FontTypeForPrint == 1 ? '標楷體' : (param.FontTypeForPrint == 2 ? '微軟正黑體' : '細明體')));
    this.type = param?.RegisterType ?? 1;

    if (this.type == 2) {
      // var borderNone = '';//有邊框(測試用)
      var borderNone = 'border-style: none;';//無邊框
      //實際紙張   13.97cm 7.62cm = 5.5 x 3 吋 含兩邊孔洞
      //伺服器格式 11.43cm 7.62cm = 4.5 x 3 吋 不含兩邊孔洞
      var ss = '11.43cm 7.62cm;';
      var st = document.createElement('style');
      st.appendChild(document.createTextNode(
        '@page { size: ' + ss + ' margin: 0cm; }\n' +
        '@media print {body {margin: 0; padding: 0; color: #000; background-color: #fff;}}\n' +
        `.reg-report table{ border:1px solid black; border-collapse: collapse;width:calc(100% - 30px);margin:0 0 0 15px; text-align: center; line-height: 1; ${borderNone}}\n` +
        `.reg-report table td, table th { border: 1px solid black;padding: 5px;vertical-align: baseline; vertical-align: middle; ${borderNone}}\n` +
        '.reg-report table tr:first-child th { border-top: 0; }\n' +
        '.reg-report table tr:last-child td { border-bottom: 0; }\n' +
        '.reg-report table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
        '.reg-report table tr td:last-child, table tr th:last-child { border-right: 0; }'
      ));
      setTimeout(() => {
        if (this.reportContainer) {
          if (!this.reportContainer.nativeElement.querySelector('style')) {
            this.reportContainer.nativeElement.appendChild(st);
            this.cdr.markForCheck();
          }
        }
      }, 0);
    } else {
      //原本的A4格式
      var st = document.createElement('style');
      st.appendChild(document.createTextNode(
        '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
        '.reg-report table{ border:1px solid black; border-collapse: collapse;width:calc(100% - 40px);margin:5px 20px; }\n' +
        '.reg-report table td, table th { border: 1px solid black;padding: 5px;vertical-align: baseline;}\n' +
        '.reg-report table tr:first-child th { border-top: 0; }\n' +
        '.reg-report table tr:last-child td { border-bottom: 0; }\n' +
        '.reg-report table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
        '.reg-report table tr td:last-child, table tr th:last-child { border-right: 0; }'
      ));
      setTimeout(() => {
        if (this.reportContainer) {
          if (!this.reportContainer.nativeElement.querySelector('style')) {
            this.reportContainer.nativeElement.appendChild(st);
            this.cdr.markForCheck();
          }
        }
      }, 0);
    }
  }

  getHtml(): string {
    var html = this.reportContainer.nativeElement.innerHTML;
    return html;
  }

}
